/**
 * Spice Class Shopify Theme - JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  initCartDrawer();
  initAddToCart();
});

/**
 * Cart Drawer
 */
function initCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return;

  // Open cart
  document.querySelectorAll('[data-action="open-cart"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });

  // Close cart
  document.querySelectorAll('[data-action="close-cart"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });
}

/**
 * Add to Cart functionality
 */
function initAddToCart() {
  document.querySelectorAll('.product-card__add-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.innerHTML;
      this.disabled = true;
      this.innerHTML = '<span class="loading-spinner" style="width:1rem;height:1rem;"></span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Update cart count
        updateCartCount();
        
        // Open cart drawer
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer) {
          refreshCartDrawer().then(() => {
            cartDrawer.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          });
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      })
      .finally(() => {
        this.disabled = false;
        this.innerHTML = originalText;
      });
    });
  });
}

/**
 * Update cart count in header
 */
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
}

/**
 * Refresh cart drawer contents
 */
function refreshCartDrawer() {
  return fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartContent = doc.querySelector('.cart-drawer__content');
      const currentCartContent = document.querySelector('.cart-drawer__content');
      
      if (newCartContent && currentCartContent) {
        currentCartContent.innerHTML = newCartContent.innerHTML;
        initCartDrawerActions();
      }
    });
}

/**
 * Initialize cart drawer action buttons (after refresh)
 */
function initCartDrawerActions() {
  // Close buttons
  document.querySelectorAll('[data-action="close-cart"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.getElementById('cart-drawer').classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  // Quantity buttons
  document.querySelectorAll('[data-action="increase-qty"], [data-action="decrease-qty"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const line = parseInt(this.dataset.line, 10);
      const action = this.dataset.action;
      const item = this.closest('.cart-drawer__item');
      const currentQty = parseInt(item.querySelector('.cart-drawer__item-quantity span').textContent, 10);
      const newQty = action === 'increase-qty' ? currentQty + 1 : currentQty - 1;

      updateCartItem(line, newQty);
    });
  });

  // Remove buttons
  document.querySelectorAll('[data-action="remove-item"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const line = parseInt(this.dataset.line, 10);
      updateCartItem(line, 0);
    });
  });
}

/**
 * Update cart item quantity
 */
function updateCartItem(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    updateCartCount();
    refreshCartDrawer();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}
